export enum EnrollmentId {
  ACCESS_TO_CONTRACT_MANAGEMENT = 10,
  RN_IQ = 15,
  SM_IQ = 16,
  SM_ELIGIBILITY = 17,
  GENERATE_INVOICE = 18,
  ACCESS_TO_INVOICING = 19,
  ACCESS_TO_INVOICE_PACKAGING = 20,
}
